import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NotFoundPage from "@/pages/NotFound";

import AppLayout from "@/components/appLayout";
import PriceMonitorPage from "@/pages/Main/PriceMonitor";
import DashboardPage from "@/pages/Main/Dashboard";
import ManagePricePage from "@/pages/Main/ManagePrice";
import PurchaseStock from "@/pages/Main/PurchaseStock";

const MainRoutes = () => (
  <Switch>
    <Redirect exact from="/main" to="/main/dashboard" />
    <AppLayout>
      <Route exact path="/main/price-monitor" component={PriceMonitorPage} />
      <Route exact path="/main/dashboard" component={DashboardPage} />
      <Route exact path="/main/manage-price" component={ManagePricePage} />
      <Route exact path="/main/purchase-stock" component={PurchaseStock} />
    </AppLayout>
  </Switch>
);

export default MainRoutes;
